import axios from 'axios';

const API_ENDPOINT = `${process.env.REACT_APP_ENDPOINT_BACKEND}/api/create/reservation`;

const createReservation = async (reservationData) => {
    try {
        const response = await axios.post(API_ENDPOINT, reservationData);
        return response.data; // Hoặc response, tùy thuộc vào API của bạn
    } catch (error) {
        // Xử lý lỗi (quan trọng!)
        console.error('Error creating reservation:', error);

        // Ném lại lỗi để component có thể xử lý nó
        throw error; // Hoặc trả về một giá trị lỗi tùy chỉnh
    }
};

const reservationService = {
    createReservation,
};

export default reservationService;